module.exports = __webpack_public_path__ + "static/media/right-arrow-white.10dc988d.svg";